const INITIAL_STATE = {
  depositsList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DEPOSITS': {
      return { ...state, depositsList: action.deposits };
    }
    default:
      return state;
  }
};
